const dataUpload = {
  wizard: {
    fileUpload: {
      title: '1. Upload de arquivo',
      body: {
        btn: 'Carregar',
        hint: 'Selecione o CSV que deseja importar',
        downloadExample: 'Baixar exemplo de CSV',
        templateLabel: 'Selecionar modelo de mapeamento (opcional)',
        templateDescription: 'Modelo carregado. Você pode visualizar ou editar a configuração abaixo, se necessário.',
        advanced: {
          hint: 'Selecione os arquivos que deseja importar',
        },
      },
    },
    mappingFields: {
      title: '2. Mapeamento de Campos',
      subTitle: 'Confirme se cada atributo corresponde à coluna correta',
      toast: 'Valor duplicado',
      selectInputPlaceHolder: 'Selecione a zona'
    },
    integrityCheck: {
      title: '3. Verificação de Integridade',
      subTitle: 'Verificando os valores dos arquivos',
    },
    import: {
      title: '4. Importar',
      subTitle: 'Importe os dados',
      doneText: 'O arquivo foi importado',
      doneBtn: 'Ok',
    },
  },

  mappingFields: {
    table: {
      fieldsInDb: 'Campos do BD',
      csvFile: 'Arquivo CSV',
      format: 'Formatar',
      defaultValue: 'Valor Padrão',
    },
    hideTableBtn: 'Ocultar tabela',
    showTableBtn: 'Mostrar tabela',
    saveAsTemplateBtn: 'Salvar como modelo',
    templateNameLabel: 'Nome do modelo',
    saveTemplateDescription: 'Salve seus mapeamentos de campo atuais como um modelo para uso futuro.',
    updateTemplateDescription: 'Você pode atualizar o modelo existente {{templateName}} ou salvar como um novo modelo.',
    saveTemplateBtn: 'Salvar',
    saveAsNewBtn: 'Salvar como novo',
    updateTemplateBtn: 'Atualizar modelo',
    nextBtn: 'Próximo',
  },

  integrityCheck: {
    showOnlyProblemBtn: 'Mostrar apenas problemas',
    disableSubmit: 'Pular Erros',
    totalCount: 'Total: {{count}}',
    exportErrorList: 'Exportar Lista de Erros',
    rowContainErroe: '{{count}} A linha contém erro.',
    importBtn: 'Importar',
    sourceFileColumn: 'Arquivo de origem',
    sourceRowColumn: 'Linha de origem',
    sourceFileFilterAll: 'Todos os {{count}} arquivos de origem',
  },

  submit: {
    errors: 'Falha ao ser movido',
  }
};

export default dataUpload;
